import { css } from '@compiled/react';

import Spinner from '@atlaskit/spinner';

import { LoomOverlayTemplate } from '@/components/signup/layouts/product-overlay-template';
import { useAccountAwareLoomExposure } from '@/components/signup/loom-land-opt-in/use-account-aware-loom-exposure';
import { SiteActivation } from '@/components/signup/site-activation/site-activation';

import { CreateASiteText } from '../../components/create-a-site-heading';
import { Headings } from '../../components/headings';
import { SitesAreSharedSpacesText } from '../../components/sub-heading';

// Loom logged-in signup for brand-new users (no existing sites). Mirrors the
// Jira/Confluence new-user structure while keeping the Loom backdrop and Loom
// copy ("Create a site" + Loom sub-heading).
//
// This surface owns post-identity exposure for the TWCG-2108 Loom Land opt-in
// experiment (STARB-4730). useAccountAwareLoomExposure re-keys the feature-gate
// client to the logged-in account, fires exposure once bucketing is stable, and
// redirects treatment cohorts to /loom/choose.
//
// We always render the Loom backdrop + modal so the branded experience is shown
// immediately (no blank screen while the account-based updateUser round-trips).
// The modal body shows a spinner until `exposureResolved`; this holds the
// site-creation form back so exposure fires post-identity and treatment cohorts
// redirect to /loom/choose before the form paints (A1 gating), while control
// users simply see the spinner briefly before the form appears.
export const LoggedInLoomNewUser = () => {
	const { exposureResolved } = useAccountAwareLoomExposure();

	return (
		<LoomOverlayTemplate size="sm">
			<div css={containerCss}>
				{exposureResolved ? (
					<>
						<Headings main={<CreateASiteText />} sub={<SitesAreSharedSpacesText />} />
						<SiteActivation useContactExpandCohortLogic />
					</>
				) : (
					<div css={loadingCss} data-testid="loom-exposure-loading">
						<Spinner size="large" />
					</div>
				)}
			</div>
		</LoomOverlayTemplate>
	);
};

const containerCss = css({
	display: 'grid',
	gap: '10px',
});

const loadingCss = css({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	// Keep the modal body from collapsing while the form is held back, so the
	// spinner sits centred in roughly the space the form will occupy.
	minHeight: '200px',
});
